import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import zh from "./locales/zh.json";
import pt from "./locales/pt.json";
import hi from "./locales/hi.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English",    nativeLabel: "English",    dir: "ltr" },
    { code: "es", label: "Spanish",    nativeLabel: "Español",    dir: "ltr" },
    { code: "fr", label: "French",     nativeLabel: "Français",   dir: "ltr" },
    { code: "zh", label: "Chinese",    nativeLabel: "中文",        dir: "ltr" },
    { code: "pt", label: "Portuguese", nativeLabel: "Português",  dir: "ltr" },
    { code: "hi", label: "Hindi",      nativeLabel: "हिन्दी",     dir: "ltr" },
    { code: "ja", label: "Japanese",   nativeLabel: "日本語",      dir: "ltr" },
    { code: "ko", label: "Korean",     nativeLabel: "한국어",      dir: "ltr" },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
            fr: { translation: fr },
            zh: { translation: zh },
            pt: { translation: pt },
            hi: { translation: hi },
            ja: { translation: ja },
            ko: { translation: ko },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "es", "fr", "zh", "pt", "hi", "ja", "ko"],
        detection: {
            // Priority order: saved language from our backend (localStorage) → browser language → default
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "passport_language",
            cacheUserLanguage: true,
        },
        interpolation: { escapeValue: false },
    });

export function applyDocumentDir(langCode) {
    const lang = SUPPORTED_LANGUAGES.find((l) => l.code === langCode);
    const dir = lang?.dir || "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", langCode);
}

// Apply on initial load
applyDocumentDir(i18n.language?.slice(0, 2));

export default i18n;
